import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

/**
 * 收藏项
 */
export interface IFavoriteInfo {
    obj_id: string;
    obj_type: number; // 收藏对象类型，1：课程；2：小节
    url: string; // 跳转链接
    update_ts: number; // 收藏时间
    is_deleted: number; // 收藏的对象是否已删除，0：未删除；1：已删除
    title: string;
    head_img: string; // 显示图片
    ext: {
        session_type: number; // 小节类型
        type_name: string; // 小节类型名称
        course_title: string;
        teacher_name: string;
        duration: number; // 小节内容时长（小节没有时长时不返回该字段）
    };
}

export interface IInput {
    page: number; // int，必填，分页页码
    size: number; // int，必填，每页展示数据量
}

export const getFavoriteList = (data: IInput): Promise<IList<IFavoriteInfo>> => {
    return fetchData(Api.GET_FAVORITE_LIST, data).then((res: IListResponse<IFavoriteInfo>) => {
        return res.data;
    });
};
